import React from "react";
import { GALLERY_PHOTOS } from "../data/menu";

// Tile size patterns to create visual interest (some span 2 cols/rows)
const SPANS = [
  "md:col-span-2 md:row-span-2",
  "",
  "",
  "md:col-span-2",
  "",
  "",
  "md:col-span-2",
  "md:row-span-2",
  "",
  "",
  "md:col-span-2",
  "",
  "",
  "",
];

export default function Gallery() {
  return (
    <main className="bg-[#0A0A0A] pt-[180px] min-h-screen" data-testid="gallery-page">
      <section className="py-12 md:py-16 max-w-7xl mx-auto px-6 md:px-12">
        <span className="text-[#D4A017] uppercase tracking-[0.3em] text-xs">Gallery</span>
        <h1 className="font-impact uppercase text-white text-5xl md:text-7xl mt-3 leading-[0.95] tracking-tight max-w-3xl">
          A visual <span className="text-[#D4A017]">tasting menu</span>.
        </h1>
        <p className="text-white/65 mt-5 max-w-2xl text-lg">
          Step inside Aradelá — the plates, the atmosphere, the spice and the smoke.
        </p>
      </section>

      <section className="pb-24 max-w-7xl mx-auto px-6 md:px-12" data-testid="gallery-grid">
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3">
          {GALLERY_PHOTOS.map((t, i) => (
            <div
              key={i}
              className={`relative overflow-hidden group ${SPANS[i % SPANS.length]}`}
              data-testid={`gallery-tile-${i}`}
            >
              <img
                src={t.src}
                alt={t.label}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
              <div className="absolute bottom-0 left-0 p-4">
                <span className="text-[#D4A017] uppercase text-[10px] tracking-[0.3em]">Aradelá</span>
                <h3 className="font-display text-white text-lg md:text-xl mt-1">{t.label}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
